import React, { useEffect } from 'react';
import { Modal } from 'flowbite-react';
import Button from '@/components/UI/Button';

declare global {
  interface Window {
    Tally?: {
      loadEmbeds: () => void;
    };
  }
}

interface TallyFormModalProps {
  show: boolean;
  onClose: () => void;
}

const TallyFormModal = ({ show, onClose }: TallyFormModalProps) => {
  useEffect(() => {
    if (show) {
      const script = document.createElement('script');
      script.src = 'https://tally.so/widgets/embed.js';
      script.async = true;
      script.onload = () => {
        if (typeof window.Tally !== 'undefined') {
          window.Tally.loadEmbeds();
        }
      };
      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
  }, [show]);

  return (
    <Modal show={show} onClose={onClose} position={'center'} size={'4xl'}>
      <Modal.Body className="p-4">
        <section className="p-4 flex flex-col gap-7">
          <iframe
            data-tally-src="https://tally.so/embed/3E67Ml?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
            loading="lazy"
            width="100%"
            height={542}
            frameBorder="0"
            marginHeight={0}
            marginWidth={0}
            title="penomo Financing Request"
          />
          <div className="flex justify-end">
            <Button primary rounded onClick={onClose} classNames="w-[120px]">Close</Button>
          </div>
        </section>
      </Modal.Body>
    </Modal>
  );
};

export default TallyFormModal; 